import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AnchorMark from "@/components/AnchorMark";
import Navbar from "@/components/sections/Navbar";
import Footer from "@/components/sections/Footer";

// Shared layout for legal pages (Privacy + Terms)
export default function LegalLayout({ title, lastUpdated, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen" style={{ backgroundColor: "#F7F5F0" }}>
      <Navbar />

      <main className="pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid={`${testId}-back-link`}
            className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#5A5D63] hover:text-[#C07865] transition-colors mb-12"
          >
            <ArrowLeft size={14} strokeWidth={1.5} />
            Return home
          </Link>

          <header className="mb-16">
            <div className="flex items-center gap-4 mb-8">
              <AnchorMark size={36} color="#15243D" />
              <p className="text-xs tracking-[0.3em] uppercase text-[#15243D]" style={{ fontWeight: 500 }}>
                ANCHOR
              </p>
            </div>
            <p className="overline mb-6">Legal</p>
            <h1
              className="serif text-5xl md:text-6xl text-[#15243D] leading-[1.05] mb-6"
              style={{ fontWeight: 300 }}
            >
              {title}
            </h1>
            <p className="text-xs tracking-[0.22em] uppercase text-[#8A8D93]">
              Last updated · {lastUpdated}
            </p>
          </header>

          <div className="prose-anchor space-y-12">{children}</div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

// Section helper used inside legal pages
export const LegalSection = ({ n, title, children }) => (
  <section className="border-t border-[#15243D]/10 pt-10">
    <div className="flex items-baseline justify-between mb-5">
      <h2
        className="serif text-2xl md:text-3xl text-[#15243D] leading-snug"
        style={{ fontWeight: 300 }}
      >
        {title}
      </h2>
      <span
        className="serif text-sm tracking-[0.2em] text-[#8A8D93]"
        style={{ fontWeight: 300 }}
      >
        {n}
      </span>
    </div>
    <div className="space-y-4 text-base md:text-lg font-light leading-relaxed text-[#5A5D63]">
      {children}
    </div>
  </section>
);
